import { defineComponent } from 'vue'

export default defineComponent({
  data () {
    return {}
  },
  computed: {},
  methods: {
    getActorLink (actor) {
      return window.location.origin + '/actors/' + actor.id
    },
  },
})
